import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-[560px] px-6 pt-32 pb-24 text-center" data-testid="payment-cancel-page">
      <div className="mx-auto mb-6" style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(230,120,120,.10)", display: "grid", placeItems: "center", border: "1px solid var(--rose)" }}>
        <XCircle size={40} color="var(--rose)" />
      </div>
      <p className="font-caps text-rose mb-4" style={{ fontSize: ".65rem", letterSpacing: ".28em" }}>Checkout cancelled</p>
      <h1 className="font-display mb-4" style={{ fontSize: "2.2rem", color: "var(--parchment)" }}>No charge was made.</h1>
      <p style={{ color: "var(--ash)", fontSize: "1rem", lineHeight: 1.6 }}>
        Your cart is right where you left it. Come back anytime to finish the order.
      </p>
      <div className="mt-10 flex gap-4 justify-center">
        <Link to="/merch" className="btn-gold" data-testid="back-to-merch">Back to merch</Link>
        <Link to="/" className="font-caps" style={{ fontSize: ".62rem", color: "var(--ash)", alignSelf: "center" }}>Back home</Link>
      </div>
    </div>
  );
}
